import React, { Component } from 'react';
import { connect } from 'react-redux';



import _ from 'underscore';

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
	state => ({
		user: state.auth.user,
	}),
)

export default class ProductHistory extends Component {

	constructor(props) {
		super(props);

		this.state = { show: false };
		this.toggleShow = this.toggleShow.bind(this);


	}


	toggleShow() {
		this.setState({ show: !this.state.show })
	}

	componentDidMount() {
		var self = this;

	}




	render() {

		var md_rows = this.props.product.md_rows;
		var history_rows = this.props.product.history_rows;

		var ar = [];

		if (md_rows) {

			if (md_rows.length > 0) {
				_.each(md_rows, (row, index) => {

					var action = row.action == 'modify_idptu' ? 'Modif ID PTU' : 'Modif N° GSM';
					var etat = 'En cours'

					if (row.etat == -1) {
						etat = <span className="text-danger"> Echec </span>
					} else if (row.etat == 0) {
						etat = <span className="text-warning"> En cours </span>
					} else {
						etat = <span className="text-success"> Succès </span>
					}

					ar.push(<div key={row.id + '-' + index}>{row.creation.substring(0, 10)} : <br />{action} <b>{etat}</b><hr style={{ margin: '3px', padding: '0px' }} /></div>)
				})

			}

			if (history_rows.length > 0) {

				_.each(history_rows, (row, index) => {

					/*var action = row.action == 'modify_idptu' ? 'Modif ID PTU' : 'Modif N° GSM';
					var etat = 'En cours'
						
					if( row.etat == -1 ) {
						etat = 'Echec'
					} else if( row.etat == 0 ) {
						etat = 'En cours'
					} else {
						etat = 'Succès'
					}*/



					ar.push(<div key={row.id + '-' + index}>{row.date_reference.substring(0, 10)} : <br />{row.action} <hr style={{ margin: '3px', padding: '0px' }} /></div>)
				})

			}
		}



		return (<div style={{ fontSize: '12px', marginTop: '10px' }}>{ar}</div>)




	}

}

